import React, { FC } from 'react'
import Store from 'src/pc/store/AppStore'
import styled from '@emotion/styled'
import DDModal from 'src/pc/components/DDModal'
import { observer } from 'mobx-react'
import { hot } from 'react-hot-loader/root'
import { AppStore } from 'src/pc/store/AppStore'

const ProtocolModal: FC<{ width?: number; height?: number }> = ({ width, height }) => {
  const finalProtocolType = Store.protocolType || 'sale'

  const cancelModal = () => {
    Store.protocolVisible = false
  }

  return (
    <StyledProtocolModal
      height={height}
      visible={Store.protocolVisible}
      title={AppStore.AgreementConfig?.[finalProtocolType]?.title}
      onCancel={cancelModal}
      afterClose={() => (Store.protocolType = null)}
      footer={false}
      width={width || 600}
      zIndex={1063}
    >
      <div dangerouslySetInnerHTML={{ __html: AppStore.AgreementConfig?.[finalProtocolType]?.content || '' }} />
    </StyledProtocolModal>
  )
}

const StyledProtocolModal = styled(DDModal)<{ height?: number }>`
  .ant-modal-body {
    max-height: ${prop => prop.height || 500}px;
    overflow: auto;
    color: var(--text-color-2);
  }
`

export default hot(observer(ProtocolModal))
